import { useState } from 'react';
import { AxiosError } from 'axios';
import useError from 'components/ErrorProvider/useError';
import { draftRealEstateReport, publishRealEstateReport } from '../api';

export function usePublishOrDraftRealEstateReport(onPublishOrDraft?: () => void) {
  const [loading, setLoading] = useState(false);
  const { addError } = useError();

  const publishOrDraftReport = async (reportId: number, isPublic: boolean) => {
    setLoading(true);

    try {
      await (isPublic ? draftRealEstateReport : publishRealEstateReport)(reportId);

      onPublishOrDraft?.();
    } catch (error) {
      addError((error as AxiosError).response?.data.message);
    } finally {
      setLoading(false);
    }
  };

  return { loading, publishOrDraftReport };
}
